// routes/DemoRequestRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import DemoRequests from '../components/DemoRequests/DemoRequests';

export const demoRequestsRoutes = (
  <Route path="/demo_requests" element={<MainLayout />}>
    <Route index element={<DemoRequests />} />
  </Route>
);
